// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2-iRB","total":"Cart_total__YiU68","actions":"Cart_actions__3qhXq","button--alt":"Cart_button--alt__3E-di","button":"Cart_button__2zbC6"};